export default __webpack_public_path__ + "static/media/MultipleUsers.a01efeea.svg";